import React, { useState, useEffect } from "react";
import "./campaign.scss";
import Header from "../header/Header";
import Switch from "react-switch";
import Modal from "react-modal";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { getCampaigns, updateCampaignStatus, deleteCampaign } from "../../../utils/apis/services/api";
import { toast } from "react-toastify";
import translate from "../../../utils/locale/language";
import Pagination from "react-js-pagination";
import Button from "../../../components/button/Button";

const Campaign = () => {
  const history = useHistory();
  const itemsPerPage = 20;
  const campaignTypes = ["Link based"];//, "Category based", "Association based"

  const [campaignsList, setCampaignsList] = useState([]);
  const [openCampaignModel, setOpenCampaignModel] = useState(false);
  const [indexIdToDelete, setIndexIdToDelete] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);

  const getCampaignsList = async (pageNum = 1) => {
    setLoader(true);
    let result = await getCampaigns(pageNum);
    setLoader(false);
    if (!result || !result.data) return;
    let raw = result.data;
    let data = raw.results ?? raw.response ?? raw.ResponseData ?? raw.data ?? (Array.isArray(raw) ? raw : null);
    if (data != null && !Array.isArray(data)) data = data.results ?? data.data ?? (data.response && (Array.isArray(data.response) ? data.response : data.response.results));
    let list = Array.isArray(data) ? data : [];
    let total = raw.count ?? raw.total_count ?? raw.total ?? (list.length && raw.next ? pageNum * itemsPerPage + 1 : list.length);
    setCampaignsList(list);
    setCount(Math.max(1, Math.ceil((Number(total) || 1) / itemsPerPage)));
  };

  useEffect(() => {
    getCampaignsList(1);
  }, []);

  const handlePageChange = (pageNum) => {
    setPage(pageNum);
    getCampaignsList(pageNum);
  };

  const goToDetails = (type, id) => {
    setOpenCampaignModel(false);
    setConfirmationModal(false);
    history.push({
      pathname: "/campaign/details",
      state: { type, id }
    });
  };

  const campaignStatusUpdate = async (id, status) => {
    let result = await updateCampaignStatus(id, status);
    if (result && (result.status === 200 || result.status === 201)) {
      toast.success(result.data?.response || "Updated");
    } else {
      toast.error(result?.data?.response || "Failed");
    }
    getCampaignsList(page);
  };

  const ToDelete = (id) => {
    setConfirmationModal(true);
    setIndexIdToDelete(id);
  };

  const campaignDelete = async () => {
    let result = await deleteCampaign(indexIdToDelete);
    if (result && (result.status === 200 || result.status === 201)) {
      toast.success(result.data?.response || "Deleted");
      setConfirmationModal(false);
    } else {
      toast.error(result?.data?.response || "Failed");
    }
    getCampaignsList(page);
  };

  const getTypeLabel = (item) => {
    let t = item?.banner_type || item?.bannerType || "";
    if (t === "linked-based") return "Link";
    // if (t === "category-based") return "Category";
    // return "Association";
    return "Link";
  };

  const getBannerImg = (item) => {
    let img = item?.banner_image;
    if (typeof img === "object") return img?.file || img?.url || "";
    if (typeof img === "number") return item?.banner_image_url || "";
    return item?.banner_image_url || item?.bannerImage?.file || item?.bannerImage?.url || "";
  };

  return (
    <div className="campaign-page">
      <Header title="Campaign" />
      <section className="campaign-container">
        <div className="campaign-header">
          <h1 className="campaign-title">{/*translate("campaign") || "Campaign"*/}</h1>
          <Button
            className="btn-primary"
            title="Create Campaign"
            onClick={() => history.push("/campaign/details", { type: "Link", id: "Create" })}
            // onClick={() => setOpenCampaignModel(true)}
          />
        </div>

        <div className="campaign-list-wrap">
          <div className="campaign-list-header">
            <div className="col-name">Name of Campaign</div>
            <div className="col-type">Campaign Type</div>
            <div className="col-loc">Country</div>
            <div className="col-status">Status</div>
            <div className="col-actions">Actions</div>
          </div>

          {loader ? (
            <div className="campaign-loader">Loading...</div>
          ) : campaignsList.length > 0 ? (
            campaignsList.map((item, index) => (
              <div key={item.id || index} className="campaign-list-row">
                <div
                  className="col-name campaign-click"
                  onClick={() => goToDetails(getTypeLabel(item), item.id)}
                >
                  <div className="campaign-img-wrap">
                    <img
                      className="campaign-img"
                      src={getBannerImg(item)}
                      alt=""
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                  <div className="campaign-info">
                    <div>{item.name}</div>
                    <div className="campaign-days">
                      {(item.weekday || item.weekdays || []).map((d, i) => (
                        <span key={i} className="days-block">
                          {(typeof d === "string" ? d : (d?.name ?? d?.slug ?? "")).substring(0, 2)}
                        </span>
                      ))}
                    </div>
                    <div className="campaign-date">
                      {(item.start_date || item.startDate) && (item.end_date || item.endDate)
                        ? `${moment(item.start_date || item.startDate).format("YYYY MMM DD")} to ${moment(item.end_date || item.endDate).format("YYYY MMM DD")}`
                        : ""}
                    </div>
                  </div>
                </div>
                <div
                  className="col-type campaign-click"
                  onClick={() => goToDetails(getTypeLabel(item), item.id)}
                >
                  {getTypeLabel(item)}
                </div>
                <div
                  className="col-loc campaign-click"
                  onClick={() => goToDetails(getTypeLabel(item), item.id)}
                >
                  {[item.country, item.state, item.city]
                    .filter(Boolean)
                    .map((v) => (v && typeof v === "object" ? (v.name ?? v.slug ?? "") : String(v)))
                    .filter(Boolean)
                    .join(" / ")}
                </div>
                <div className="col-status">
                  <Switch
                    checked={!!(item.is_active !== undefined ? item.is_active : item.isActive)}
                    onColor="#00A739"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onChange={(checked) => campaignStatusUpdate(item.id, checked)}
                  />
                </div>
                <div className="col-actions">
                  <i
                    className="fa fa-edit"
                    onClick={() => goToDetails(getTypeLabel(item), item.id)}
                    style={{ cursor: "pointer", marginRight: 8 }}
                  />
                  <i
                    className="fa fa-trash"
                    onClick={() => ToDelete(item.id)}
                    style={{ cursor: "pointer", color: "#eb2813" }}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="campaign-empty">No campaigns yet. Create one to get started.</div>
          )}
        </div>

        {count > 1 && (
          <div className="campaign-pagination-bottom" style={{ justifyContent: 'flex-end' }}>
            <Pagination
              activePage={page}
              itemsCountPerPage={itemsPerPage}
              totalItemsCount={count * itemsPerPage}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            />
          </div>
        )}

        <Modal
          isOpen={openCampaignModel}
          className="campaign-modal"
          overlayClassName="campaign-modal-overlay"
          onRequestClose={() => setOpenCampaignModel(false)}
          contentLabel="Create Campaign"
        >
          <div className="campaign-modal-inner">
            <div className="campaign-modal-close" onClick={() => setOpenCampaignModel(false)}>
              <i className="fa fa-times" />
            </div>
            <div className="campaign-types">
              {campaignTypes.map((item) => (
                <div
                  key={item}
                  className="campaign-type-item"
                  onClick={() =>
                    goToDetails(
                      item === "Link based" ? "Link" : item === "Category based" ? "Category" : "Association",
                      "Create"
                    )
                  }
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={confirmationModal}
          className="campaign-modal campaign-confirm-modal"
          overlayClassName="campaign-modal-overlay"
          onRequestClose={() => setConfirmationModal(false)}
          contentLabel="Delete confirmation"
        >
          <div className="campaign-confirm-inner">
            <p>Are you sure you want to delete this campaign?</p>
            <div className="campaign-confirm-actions">
              <Button title="Cancel" onClick={() => setConfirmationModal(false)} />
              <Button title="Delete" onClick={campaignDelete} className="btn-primary" />
            </div>
          </div>
        </Modal>
      </section>
    </div>
  );
};

export default Campaign;
